import React, { useEffect, useState } from "react";
import MyProfilesidebar from "../Myprofile/MyProfilesidebar";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { api } from "../../Constant";

const Orders = () => {
  const [orders, setOrders] = useState([]);

  // Unified method to return the correct identifier object
  const getUserIdentifier = () => {
    const userId = localStorage.getItem("userId");
    const guestId = localStorage.getItem("guest_id");

    const isGuest = userId === guestId;
    if (isGuest) return { guest_id: guestId };
    if (userId) return { user_id: userId };
    return null;
  };

  useEffect(() => {
    const fetchOrders = async () => {
      const identifier = getUserIdentifier();
      if (!identifier) {
        console.warn("No user or guest ID found.");
        return;
      }

      try {
        const response = await axios.post(api + "my_orders", identifier);
        console.log("Order API Response:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setOrders(response.data.data);
        } else {
          setOrders([]); // handle gracefully if no orders
        }
      } catch (error) {
        console.error("Failed to fetch orders", error);
      }
    };

    fetchOrders();
  }, []);

  return (
    <div className="myprofile-bg pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
            <MyProfilesidebar />
          </div>
          <div className="col-lg-9">
            <div className="myprofile-overview ordersmain-bg">
              <div className="title-order-top">
                <h4>Orders</h4>
                <select>
                  <option value="">Select a Month</option>
                  <option value="3">Past 3 Months</option>
                  <option value="2">Past 2 Months</option>
                  <option value="1">Past 1 Month</option>
                </select>
              </div>
              <Tabs>
                <TabList>
                  <Tab>Order</Tab>
                </TabList>
                <TabPanel className="product-track-main">
                  {orders.length === 0 ? (
                    <p>No orders found.</p>
                  ) : (
                    orders.map((order, index) => (
                      <div className="row track-top" key={index}>
                        <div className="col-lg-5 col-md-5">
                          {order.description.map((item, i) => (
                            <div className="product-track-flex" key={i}>
                              <div>
                                <img
                                  src={item.product_image}
                                  alt={item.product_name}
                                  style={{ width: "80px", height: "auto" }}
                                />
                              </div>
                              <div>
                                <h6>{item.product_name}</h6>
                                <p>{item.product_quantity} Qty</p>
                                <p>₹ {item.product_amount}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <h6>Order Placed On: {order.created_date}</h6>
                          <p>Total Items: {order.description.length}</p>
                          <p>Order Total: ₹ {order.total}</p>
                        </div>
                        <div className="col-lg-3 col-md-3 track-order-btn">
                          <Link to={`/order-detail/${order.order_id}`}>
                            Order Detail
                          </Link>
                        </div>
                      </div>
                    ))
                  )}
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
